import { bool, object } from "prop-types";
import { observer } from "mobx-react";
import { PriceFormats, SummaryColumns } from "@repo/utils";
import { useEstimateStructure, useVisibilityModeCellClassName, ValueCell } from "@tools";
import { MAX_VALUES } from "@utils";

export const CostCell = observer(({
  element,
  ...props
}) => {
  const structure = useEstimateStructure();
  const className = useVisibilityModeCellClassName(structure.visibility.hideSummaryCost);
  
  const { displayAnyValue, showFixedDecimalPrices } = structure;
  const { currencyObj, roundPrice, priceFormat } = structure.settings;
  const { displayPrice, displayPriceMax, showMaxPrice } = element;
  
  return (
    <ValueCell
      colName={ SummaryColumns.COST }
      displayContent
      useDynamicWidth
      useInputBackground
      usePriceFormat
      emptyInputs={!displayAnyValue}
      value={displayPrice}
      valueMax={displayPriceMax}
      min={-MAX_VALUES.PRICE}
      max={MAX_VALUES.PRICE}
      displayMax={showMaxPrice}
      symbolStart={currencyObj.symbolStart}
      symbolEnd={currencyObj.symbolEnd}
      americanFormat={priceFormat === PriceFormats.AMERICAN}
      showDecimals={!roundPrice}
      fixedDecimalScale={showFixedDecimalPrices}
      allowNegative
      className={className}
      inputClassName="input-price"
      textPresetClass="preset-price"
      applySuffixSpacing
      {...props}
    />
  );
});

CostCell.propTypes = {
  element: object.isRequired,
  extendPadding: bool,
};
